// Generated by src/scripts/generate_emoji_skin_tones.js. Do not edit manually.
const EmojiSkinToneTemplates: {[emoji: string]: string} = {
  '1f385': '🎅🏻',
  '1f3c2': '🏂🏻',
  '1f3c3': '🏃🏻',
  '1f3c3-200d-2640': '🏃🏻‍♀',
  '1f3c3-200d-2640-200d-27a1': '🏃🏻‍♀‍➡',
  '1f3c3-200d-2642': '🏃🏻‍♂',
  '1f3c3-200d-2642-200d-27a1': '🏃🏻‍♂‍➡',
  '1f3c3-200d-27a1': '🏃🏻‍➡',
  '1f3c4': '🏄🏻',
  '1f3c4-200d-2640': '🏄🏻‍♀',
  '1f3c4-200d-2642': '🏄🏻‍♂',
  '1f3c7': '🏇🏻',
  '1f3ca': '🏊🏻',
  '1f3ca-200d-2640': '🏊🏻‍♀',
  '1f3ca-200d-2642': '🏊🏻‍♂',
  '1f3cb': '🏋🏻',
  '1f3cb-200d-2640': '🏋🏻‍♀',
  '1f3cb-200d-2642': '🏋🏻‍♂',
  '1f3cc': '🏌🏻',
  '1f3cc-200d-2640': '🏌🏻‍♀',
  '1f3cc-200d-2642': '🏌🏻‍♂',
  '1f442': '👂🏻',
  '1f443': '👃🏻',
  '1f446': '👆🏻',
  '1f447': '👇🏻',
  '1f448': '👈🏻',
  '1f449': '👉🏻',
  '1f44a': '👊🏻',
  '1f44b': '👋🏻',
  '1f44c': '👌🏻',
  '1f44d': '👍🏻',
  '1f44e': '👎🏻',
  '1f44f': '👏🏻',
  '1f450': '👐🏻',
  '1f466': '👦🏻',
  '1f467': '👧🏻',
  '1f468': '👨🏻',
  '1f468-200d-1f33e': '👨🏻‍🌾',
  '1f468-200d-1f373': '👨🏻‍🍳',
  '1f468-200d-1f37c': '👨🏻‍🍼',
  '1f468-200d-1f393': '👨🏻‍🎓',
  '1f468-200d-1f3a4': '👨🏻‍🎤',
  '1f468-200d-1f3a8': '👨🏻‍🎨',
  '1f468-200d-1f3eb': '👨🏻‍🏫',
  '1f468-200d-1f3ed': '👨🏻‍🏭',
  '1f468-200d-1f4bb': '👨🏻‍💻',
  '1f468-200d-1f4bc': '👨🏻‍💼',
  '1f468-200d-1f527': '👨🏻‍🔧',
  '1f468-200d-1f52c': '👨🏻‍🔬',
  '1f468-200d-1f680': '👨🏻‍🚀',
  '1f468-200d-1f692': '👨🏻‍🚒',
  '1f468-200d-1f9af': '👨🏻‍🦯',
  '1f468-200d-1f9af-200d-27a1': '👨🏻‍🦯‍➡',
  '1f468-200d-1f9b0': '👨🏻‍🦰',
  '1f468-200d-1f9b1': '👨🏻‍🦱',
  '1f468-200d-1f9b2': '👨🏻‍🦲',
  '1f468-200d-1f9b3': '👨🏻‍🦳',
  '1f468-200d-1f9bc': '👨🏻‍🦼',
  '1f468-200d-1f9bc-200d-27a1': '👨🏻‍🦼‍➡',
  '1f468-200d-1f9bd': '👨🏻‍🦽',
  '1f468-200d-1f9bd-200d-27a1': '👨🏻‍🦽‍➡',
  '1f468-200d-2695': '👨🏻‍⚕',
  '1f468-200d-2696': '👨🏻‍⚖',
  '1f468-200d-2708': '👨🏻‍✈',
  '1f468-200d-2764-200d-1f468': '👨🏻‍❤‍👨🏻',
  '1f468-200d-2764-200d-1f48b-200d-1f468': '👨🏻‍❤‍💋‍👨🏻',
  '1f469': '👩🏻',
  '1f469-200d-1f33e': '👩🏻‍🌾',
  '1f469-200d-1f373': '👩🏻‍🍳',
  '1f469-200d-1f37c': '👩🏻‍🍼',
  '1f469-200d-1f393': '👩🏻‍🎓',
  '1f469-200d-1f3a4': '👩🏻‍🎤',
  '1f469-200d-1f3a8': '👩🏻‍🎨',
  '1f469-200d-1f3eb': '👩🏻‍🏫',
  '1f469-200d-1f3ed': '👩🏻‍🏭',
  '1f469-200d-1f4bb': '👩🏻‍💻',
  '1f469-200d-1f4bc': '👩🏻‍💼',
  '1f469-200d-1f527': '👩🏻‍🔧',
  '1f469-200d-1f52c': '👩🏻‍🔬',
  '1f469-200d-1f680': '👩🏻‍🚀',
  '1f469-200d-1f692': '👩🏻‍🚒',
  '1f469-200d-1f9af': '👩🏻‍🦯',
  '1f469-200d-1f9af-200d-27a1': '👩🏻‍🦯‍➡',
  '1f469-200d-1f9b0': '👩🏻‍🦰',
  '1f469-200d-1f9b1': '👩🏻‍🦱',
  '1f469-200d-1f9b2': '👩🏻‍🦲',
  '1f469-200d-1f9b3': '👩🏻‍🦳',
  '1f469-200d-1f9bc': '👩🏻‍🦼',
  '1f469-200d-1f9bc-200d-27a1': '👩🏻‍🦼‍➡',
  '1f469-200d-1f9bd': '👩🏻‍🦽',
  '1f469-200d-1f9bd-200d-27a1': '👩🏻‍🦽‍➡',
  '1f469-200d-2695': '👩🏻‍⚕',
  '1f469-200d-2696': '👩🏻‍⚖',
  '1f469-200d-2708': '👩🏻‍✈',
  '1f469-200d-2764-200d-1f468': '👩🏻‍❤‍👨🏻',
  '1f469-200d-2764-200d-1f469': '👩🏻‍❤‍👩🏻',
  '1f469-200d-2764-200d-1f48b-200d-1f468': '👩🏻‍❤‍💋‍👨🏻',
  '1f469-200d-2764-200d-1f48b-200d-1f469': '👩🏻‍❤‍💋‍👩🏻',
  '1f46b': '👫🏻',
  '1f46c': '👬🏻',
  '1f46d': '👭🏻',
  '1f46e': '👮🏻',
  '1f46e-200d-2640': '👮🏻‍♀',
  '1f46e-200d-2642': '👮🏻‍♂',
  '1f470': '👰🏻',
  '1f470-200d-2640': '👰🏻‍♀',
  '1f470-200d-2642': '👰🏻‍♂',
  '1f471': '👱🏻',
  '1f471-200d-2640': '👱🏻‍♀',
  '1f471-200d-2642': '👱🏻‍♂',
  '1f472': '👲🏻',
  '1f473': '👳🏻',
  '1f473-200d-2640': '👳🏻‍♀',
  '1f473-200d-2642': '👳🏻‍♂',
  '1f474': '👴🏻',
  '1f475': '👵🏻',
  '1f476': '👶🏻',
  '1f477': '👷🏻',
  '1f477-200d-2640': '👷🏻‍♀',
  '1f477-200d-2642': '👷🏻‍♂',
  '1f478': '👸🏻',
  '1f47c': '👼🏻',
  '1f481': '💁🏻',
  '1f481-200d-2640': '💁🏻‍♀',
  '1f481-200d-2642': '💁🏻‍♂',
  '1f482': '💂🏻',
  '1f482-200d-2640': '💂🏻‍♀',
  '1f482-200d-2642': '💂🏻‍♂',
  '1f483': '💃🏻',
  '1f485': '💅🏻',
  '1f486': '💆🏻',
  '1f486-200d-2640': '💆🏻‍♀',
  '1f486-200d-2642': '💆🏻‍♂',
  '1f487': '💇🏻',
  '1f487-200d-2640': '💇🏻‍♀',
  '1f487-200d-2642': '💇🏻‍♂',
  '1f48f': '💏🏻',
  '1f491': '💑🏻',
  '1f4aa': '💪🏻',
  '1f574': '🕴🏻',
  '1f575': '🕵🏻',
  '1f575-200d-2640': '🕵🏻‍♀',
  '1f575-200d-2642': '🕵🏻‍♂',
  '1f57a': '🕺🏻',
  '1f590': '🖐🏻',
  '1f595': '🖕🏻',
  '1f596': '🖖🏻',
  '1f645': '🙅🏻',
  '1f645-200d-2640': '🙅🏻‍♀',
  '1f645-200d-2642': '🙅🏻‍♂',
  '1f646': '🙆🏻',
  '1f646-200d-2640': '🙆🏻‍♀',
  '1f646-200d-2642': '🙆🏻‍♂',
  '1f647': '🙇🏻',
  '1f647-200d-2640': '🙇🏻‍♀',
  '1f647-200d-2642': '🙇🏻‍♂',
  '1f64b': '🙋🏻',
  '1f64b-200d-2640': '🙋🏻‍♀',
  '1f64b-200d-2642': '🙋🏻‍♂',
  '1f64c': '🙌🏻',
  '1f64d': '🙍🏻',
  '1f64d-200d-2640': '🙍🏻‍♀',
  '1f64d-200d-2642': '🙍🏻‍♂',
  '1f64e': '🙎🏻',
  '1f64e-200d-2640': '🙎🏻‍♀',
  '1f64e-200d-2642': '🙎🏻‍♂',
  '1f64f': '🙏🏻',
  '1f6a3': '🚣🏻',
  '1f6a3-200d-2640': '🚣🏻‍♀',
  '1f6a3-200d-2642': '🚣🏻‍♂',
  '1f6b4': '🚴🏻',
  '1f6b4-200d-2640': '🚴🏻‍♀',
  '1f6b4-200d-2642': '🚴🏻‍♂',
  '1f6b5': '🚵🏻',
  '1f6b5-200d-2640': '🚵🏻‍♀',
  '1f6b5-200d-2642': '🚵🏻‍♂',
  '1f6b6': '🚶🏻',
  '1f6b6-200d-2640': '🚶🏻‍♀',
  '1f6b6-200d-2640-200d-27a1': '🚶🏻‍♀‍➡',
  '1f6b6-200d-2642': '🚶🏻‍♂',
  '1f6b6-200d-2642-200d-27a1': '🚶🏻‍♂‍➡',
  '1f6b6-200d-27a1': '🚶🏻‍➡',
  '1f6c0': '🛀🏻',
  '1f6cc': '🛌🏻',
  '1f90c': '🤌🏻',
  '1f90f': '🤏🏻',
  '1f918': '🤘🏻',
  '1f919': '🤙🏻',
  '1f91a': '🤚🏻',
  '1f91b': '🤛🏻',
  '1f91c': '🤜🏻',
  '1f91d': '🤝🏻',
  '1f91e': '🤞🏻',
  '1f91f': '🤟🏻',
  '1f926': '🤦🏻',
  '1f926-200d-2640': '🤦🏻‍♀',
  '1f926-200d-2642': '🤦🏻‍♂',
  '1f930': '🤰🏻',
  '1f931': '🤱🏻',
  '1f932': '🤲🏻',
  '1f933': '🤳🏻',
  '1f934': '🤴🏻',
  '1f935': '🤵🏻',
  '1f935-200d-2640': '🤵🏻‍♀',
  '1f935-200d-2642': '🤵🏻‍♂',
  '1f936': '🤶🏻',
  '1f937': '🤷🏻',
  '1f937-200d-2640': '🤷🏻‍♀',
  '1f937-200d-2642': '🤷🏻‍♂',
  '1f938': '🤸🏻',
  '1f938-200d-2640': '🤸🏻‍♀',
  '1f938-200d-2642': '🤸🏻‍♂',
  '1f939': '🤹🏻',
  '1f939-200d-2640': '🤹🏻‍♀',
  '1f939-200d-2642': '🤹🏻‍♂',
  '1f93d': '🤽🏻',
  '1f93d-200d-2640': '🤽🏻‍♀',
  '1f93d-200d-2642': '🤽🏻‍♂',
  '1f93e': '🤾🏻',
  '1f93e-200d-2640': '🤾🏻‍♀',
  '1f93e-200d-2642': '🤾🏻‍♂',
  '1f977': '🥷🏻',
  '1f9b5': '🦵🏻',
  '1f9b6': '🦶🏻',
  '1f9b8': '🦸🏻',
  '1f9b8-200d-2640': '🦸🏻‍♀',
  '1f9b8-200d-2642': '🦸🏻‍♂',
  '1f9b9': '🦹🏻',
  '1f9b9-200d-2640': '🦹🏻‍♀',
  '1f9b9-200d-2642': '🦹🏻‍♂',
  '1f9bb': '🦻🏻',
  '1f9cd': '🧍🏻',
  '1f9cd-200d-2640': '🧍🏻‍♀',
  '1f9cd-200d-2642': '🧍🏻‍♂',
  '1f9ce': '🧎🏻',
  '1f9ce-200d-2640': '🧎🏻‍♀',
  '1f9ce-200d-2640-200d-27a1': '🧎🏻‍♀‍➡',
  '1f9ce-200d-2642': '🧎🏻‍♂',
  '1f9ce-200d-2642-200d-27a1': '🧎🏻‍♂‍➡',
  '1f9ce-200d-27a1': '🧎🏻‍➡',
  '1f9cf': '🧏🏻',
  '1f9cf-200d-2640': '🧏🏻‍♀',
  '1f9cf-200d-2642': '🧏🏻‍♂',
  '1f9d1': '🧑🏻',
  '1f9d1-200d-1f33e': '🧑🏻‍🌾',
  '1f9d1-200d-1f373': '🧑🏻‍🍳',
  '1f9d1-200d-1f37c': '🧑🏻‍🍼',
  '1f9d1-200d-1f384': '🧑🏻‍🎄',
  '1f9d1-200d-1f393': '🧑🏻‍🎓',
  '1f9d1-200d-1f3a4': '🧑🏻‍🎤',
  '1f9d1-200d-1f3a8': '🧑🏻‍🎨',
  '1f9d1-200d-1f3eb': '🧑🏻‍🏫',
  '1f9d1-200d-1f3ed': '🧑🏻‍🏭',
  '1f9d1-200d-1f4bb': '🧑🏻‍💻',
  '1f9d1-200d-1f4bc': '🧑🏻‍💼',
  '1f9d1-200d-1f527': '🧑🏻‍🔧',
  '1f9d1-200d-1f52c': '🧑🏻‍🔬',
  '1f9d1-200d-1f680': '🧑🏻‍🚀',
  '1f9d1-200d-1f692': '🧑🏻‍🚒',
  '1f9d1-200d-1f91d-200d-1f9d1': '🧑🏻‍🤝‍🧑🏻',
  '1f9d1-200d-1f9af': '🧑🏻‍🦯',
  '1f9d1-200d-1f9af-200d-27a1': '🧑🏻‍🦯‍➡',
  '1f9d1-200d-1f9b0': '🧑🏻‍🦰',
  '1f9d1-200d-1f9b1': '🧑🏻‍🦱',
  '1f9d1-200d-1f9b2': '🧑🏻‍🦲',
  '1f9d1-200d-1f9b3': '🧑🏻‍🦳',
  '1f9d1-200d-1f9bc': '🧑🏻‍🦼',
  '1f9d1-200d-1f9bc-200d-27a1': '🧑🏻‍🦼‍➡',
  '1f9d1-200d-1f9bd': '🧑🏻‍🦽',
  '1f9d1-200d-1f9bd-200d-27a1': '🧑🏻‍🦽‍➡',
  '1f9d1-200d-2695': '🧑🏻‍⚕',
  '1f9d1-200d-2696': '🧑🏻‍⚖',
  '1f9d1-200d-2708': '🧑🏻‍✈',
  '1f9d2': '🧒🏻',
  '1f9d3': '🧓🏻',
  '1f9d4': '🧔🏻',
  '1f9d4-200d-2640': '🧔🏻‍♀',
  '1f9d4-200d-2642': '🧔🏻‍♂',
  '1f9d5': '🧕🏻',
  '1f9d6': '🧖🏻',
  '1f9d6-200d-2640': '🧖🏻‍♀',
  '1f9d6-200d-2642': '🧖🏻‍♂',
  '1f9d7': '🧗🏻',
  '1f9d7-200d-2640': '🧗🏻‍♀',
  '1f9d7-200d-2642': '🧗🏻‍♂',
  '1f9d8': '🧘🏻',
  '1f9d8-200d-2640': '🧘🏻‍♀',
  '1f9d8-200d-2642': '🧘🏻‍♂',
  '1f9d9': '🧙🏻',
  '1f9d9-200d-2640': '🧙🏻‍♀',
  '1f9d9-200d-2642': '🧙🏻‍♂',
  '1f9da': '🧚🏻',
  '1f9da-200d-2640': '🧚🏻‍♀',
  '1f9da-200d-2642': '🧚🏻‍♂',
  '1f9db': '🧛🏻',
  '1f9db-200d-2640': '🧛🏻‍♀',
  '1f9db-200d-2642': '🧛🏻‍♂',
  '1f9dc': '🧜🏻',
  '1f9dc-200d-2640': '🧜🏻‍♀',
  '1f9dc-200d-2642': '🧜🏻‍♂',
  '1f9dd': '🧝🏻',
  '1f9dd-200d-2640': '🧝🏻‍♀',
  '1f9dd-200d-2642': '🧝🏻‍♂',
  '1fac3': '🫃🏻',
  '1fac4': '🫄🏻',
  '1fac5': '🫅🏻',
  '1faf0': '🫰🏻',
  '1faf1': '🫱🏻',
  '1faf2': '🫲🏻',
  '1faf3': '🫳🏻',
  '1faf4': '🫴🏻',
  '1faf5': '🫵🏻',
  '1faf6': '🫶🏻',
  '1faf7': '🫷🏻',
  '1faf8': '🫸🏻',
  '261d': '☝🏻',
  '26f9': '⛹🏻',
  '26f9-200d-2640': '⛹🏻‍♀',
  '26f9-200d-2642': '⛹🏻‍♂',
  '270a': '✊🏻',
  '270b': '✋🏻',
  '270c': '✌🏻',
  '270d': '✍🏻'
};

export default EmojiSkinToneTemplates;
